import React from "react";
import classes from "./BulkUploadError.scss";
import { saveAs } from "file-saver";
import { Button, Modal } from "@toddle-edu/ds-web";
import I18nHOC from "UIComponents/I18nHOC";
import UIBaseComponent from "UIComponents/UIBaseComponent";

class BulkUploadError extends UIBaseComponent {
  onClose = () => {
    return this.props.toggleBulkUploadErrorModal();
  };

  onDownloadClick = () => {
    //loop to get a random number
    const errorMessageFormatted = JSON.stringify(this.props.errors, null, "\t")
      .replace(/\t/g, "")
      .replace(/\[/g, "")
      .replace(/]/g, "")
      .replace(/{/g, "")
      .replace(/}/g, "")
      .replace(/"/g, "");

    const blob = new Blob([errorMessageFormatted], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(blob, "errors.txt");
    return this.props.toggleBulkUploadErrorModal();
  };

  renderEdit = () => {
    const { t } = this.props;
    return (
      <Modal
        isOpen={true}
        onClose={this.onClose}
        height={"170px"}
        width={"440px"}
      >
        <Modal.Header isClosable={true}>
          {t("common:errors_found_in_list")}
        </Modal.Header>

        <Modal.Footer>
          <div className={classes.buttonContainer}>
            <Button
              size="medium"
              variant="outlined-subtle"
              onClick={this.onClose}
            >
              {t("common:close")}
            </Button>
            <Button size="medium" onClick={this.onDownloadClick}>
              {t("common:download_error_list")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };
}

BulkUploadError.defaultProps = {
  ...UIBaseComponent.defaultProps,
};

BulkUploadError.propTypes = {
  ...UIBaseComponent.propTypes,
};

export default I18nHOC({ resource: "common" })(BulkUploadError);
